import Button from "../components/Button";
import { Link } from "react-router-dom";

import peugeot from "../../src/assets/svg/primary-logo.svg";

const NotFound = () => {
  return (
    <div className="flex flex-col items-center w-full gap-6 pt-[120px] sm:pt-[140px] px-6 pb-8">
      {/* Upper half*/}
      <div className="flex flex-col items-center w-full pb-6 border-b border-extra-light">
        <div className="flex flex-col gap-6">
          <img src={peugeot} alt="Page not found"></img>
          <p className="font-bold text-center text-[40px] sm:text-[50px] text-primary-blue">
            404
          </p>
        </div>
      </div>

      {/* Lower half*/}
      <div className="flex flex-col items-center gap-4 max-w-[558px]">
        <h1 className="text-base font-bold text-center text-gray-extra-dark">
          NEPOSTOJEĆA STRANICA
        </h1>
        <span className="text-[13px] text-center text-gray-extra-dark text-opacity-80">
          Čini se da ova stranica trenutno ne postoji. Pokušajte ponovno, ili se
          vratite na početnu stranicu.
        </span>
      </div>

      {/* Navigation button */}
      <Link to={"/"} className="w-full sm:w-auto">
        <Button
          text={"Početna stranica"}
          variant={"primary"}
          size={"base"}
          width="w-full"
        ></Button>
      </Link>
    </div>
  );
};

export default NotFound;
